import {isEmpty} from 'lodash';

interface ConceptRawData {
  name: string;
  messageKey: string;
  backgroundColor: string;
}

export class ConceptsConfig {
  private readonly rawData: Partial<ConceptRawData[]>;

  private readonly loaded: boolean;

  constructor(rawData: Partial<ConceptRawData[]> = []) {
    this.rawData = [...rawData];
    this.loaded = !isEmpty(this.rawData);
  }

  getConcepts(): ConceptRawData[] | undefined {
    return this.rawData;
  }

  isLoaded() {
    return this.loaded;
  }
}

export default {ConceptsConfig};
